import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Select, Table } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { api, endpoints } from '../../api';
import { routerPath } from '../../router/routerPath';
import {
  BlueLayout,
  CustomButton,
  CustomSelect,
  CustomTableContainer,
  FormBlock,
  GridItem,
  PagesContainerUI,
} from '../../styles/styled';
import { sortRegions } from '../../utils/sortObject';
import { RegionsType } from '../ExpertPage/types';
import { PovsResponseType, PovsType, PovType } from '../PovsLkPage/types';
import { PaginationType } from '../TextbooksPage/types';

const { Option } = Select;

export const LkPovsPage = () => {
  const [regionsList, setRegions] = useState<RegionsType>([]);
  const [povsState, setPovsState] = useState<PovsType[] | null>(null);
  const [regionInput, setRegionInput] = useState<number | null>(null);
  const [searchState, setSearchState] = useState<boolean>(false);
  const [paginationState, setPaginationState] = useState<PaginationType>({ pagination: 1, perPage: 0, total: 0 });
  const loadPagination = useRef(true);
  const navigate = useNavigate();

  const regionSelect = useMemo(() => {
    if (!regionInput) {
      return '';
    }

    return regionsList.find((el) => el.id.toString() === regionInput.toString())?.title;
  }, [regionInput, regionsList]);

  useEffect(() => {
    (async () => {
      try {
        const response = await api.get<PovsResponseType>(
          endpoints.getPovs(
            searchState && regionInput ? { region: regionInput } : { page: paginationState.pagination - 1 },
          ),
        );

        if (loadPagination.current) {
          setPaginationState({ ...paginationState, total: response.data.count });
          loadPagination.current = false;
        }

        setPovsState(
          response.data.povs.map((el, idx) => {
            return { ...el, key: idx + 1 };
          }),
        );
      } catch (err) {}
    })();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchState, paginationState]);

  const lkPovsColumns = [
    {
      title: '№ п/п',
      dataIndex: 'key',
      key: 'key',
    },
    {
      title: 'Регион',
      dataIndex: 'region',
      key: 'region',
      render: (region: { title: string } | null, povs: PovsType) => (
        <Link className="text-link" to={routerPath.editPovs + '/' + povs.id}>
          {region ? region?.title : '-'}
        </Link>
      ),
    },
    {
      title: 'Наименование органа власти',
      dataIndex: 'povs',
      key: 'name_of_organization',
      render: (pov: PovType, povs: PovsType) => <p>{pov?.gov_name || povs?.name_of_organization}</p>,
    },
    {
      title: 'Контакты',
      dataIndex: 'povs',
      key: 'phone ',
      render: (pov: PovType, povs: PovsType) => <p>{pov?.email_gov || povs?.phone}</p>,
    },
  ];

  useEffect(() => {
    (async () => {
      try {
        const regionsResponse = await api.get<RegionsType>(endpoints.getRegions());

        setRegions(regionsResponse.data.sort(sortRegions));
      } catch (err) {}
    })();
  }, []);

  return (
    <PagesContainerUI>
      <BlueLayout>ПОВС</BlueLayout>

      <FormBlock padding="50px">
        <GridItem align="center" gap="25px" justify="center" direction="column">
          <GridItem align="flex-start" justify="flex-start" direction="column">
            <div className="text">Регион</div>
            <CustomSelect
              onChange={(value, option) => setRegionInput(Object.values(option)[0] as number)}
              value={regionSelect}
              showSearch
            >
              {regionsList.map((region) => {
                return (
                  <Option key={region.id} value={region.title}>
                    {region.title}
                  </Option>
                );
              })}
            </CustomSelect>
          </GridItem>
          <GridItem align="center" justify="space-around" direction="row">
            <CustomButton
              onClick={() => {
                setSearchState(true);
                setPaginationState({ ...paginationState, pagination: 1 });
                loadPagination.current = true;
              }}
            >
              Найти
            </CustomButton>
            <CustomButton
              lined
              onClick={() => {
                setPaginationState({ ...paginationState, pagination: 1 });
                setSearchState(false);
                setRegionInput(null);
                loadPagination.current = true;
              }}
            >
              Очистить
            </CustomButton>
          </GridItem>
        </GridItem>
      </FormBlock>

      <GridItem align="flex-end" justify="flex-end">
        <CustomButton width="300px" onClick={() => navigate(routerPath.createPovsMember)}>
          Добавить ПОВС
        </CustomButton>
      </GridItem>

      <CustomTableContainer>
        <Table
          pagination={{
            current: paginationState.pagination,
            onChange: (value: number) => setPaginationState({ ...paginationState, pagination: value }),
            total: paginationState.total,
          }}
          columns={lkPovsColumns}
          dataSource={povsState || []}
        />
      </CustomTableContainer>
    </PagesContainerUI>
  );
};
